import React, { useEffect, useRef } from "react"; // useState
import { insertTextbeforeUrlExtention } from "../utils/general/text-formatting.js";
import { res_housing_association_carousel } from "../utils/config/image-resolutions.js";
import { housing_associations } from "../utils/config/housing_associations.js";
import { handleScaleInlineTailwind300 } from "../utils/animations/animations.js";
import { ImageLoader } from "./ImageLoaders.jsx";

const housing_association_scroll = (num) => {
  return Object.values(housing_associations).filter((housing_association) => housing_association.active).map((housing_association, index) => (
    <button
      aria-label={`Open ${housing_association.name}'s website`}
      key={`btn${index}${num}`}
      onClick={() => window.open(housing_association.link, "_blank")}
      className={`flex-none h-full transition-transform duration-300 py-4 ${handleScaleInlineTailwind300}`}
      onMouseEnter={(e) => e.currentTarget.classList.add("scale-110")}
      onMouseLeave={(e) => e.currentTarget.classList.remove("scale-110")}
    >
      <ImageLoader
        src={insertTextbeforeUrlExtention(housing_association.main_logo_url, res_housing_association_carousel)}
        alt={housing_association.name}
        containerClass="h-full w-full"
        imageClass="h-full w-auto object-cover py-4 px-8 overflow-hidden"
      />
    </button>
  ));
};

export default function HousingAssociationCarousel() {
  const carouselRef = useRef(null);

  useEffect(() => {
    const carousel = carouselRef.current;

    const handleScroll = () => {
      if (carousel.scrollLeft >= carousel.scrollWidth / 2) {
        carousel.scrollLeft = 0;
      } else {
        carousel.scrollLeft += 1;
      }
    };

    const intervalId = setInterval(handleScroll, 20); // Adjust the speed as needed

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="w-full h-24 sm:h-32 relative bg-white">
      <div ref={carouselRef} className="absolute overflow-hidden w-full h-full flex flex-nowrap">
        <div className="flex h-full items-center gap-8">
          {housing_association_scroll(1)}
          {housing_association_scroll(2)}
        </div>
      </div>

      <div className={`absolute top-1/2 transform -translate-y-1/2 left-0 h-full flex flex-row`}>
        <div className="flex h-full pl-8 pr-4 bg-white items-center"></div>
        <div className="w-32 h-full bg-gradient-to-r from-white to-transparent"></div>
      </div>

      <div className={`absolute top-1/2 transform -translate-y-1/2 right-0 h-full flex flex-row`}>
        <div className="w-32 h-full bg-gradient-to-l from-white to-transparent"></div>
        <div className="flex h-full pr-8 pl-4 bg-white items-center"></div>
      </div>
    </div>
  );
}
